module.exports = __webpack_public_path__ + "img/female_full.9300c377.png";